// True when an HTTP request got no answer from the server (offline, a network
// change, a blocked request): that is a device condition, not a fault to
// report. Other errors, such as a code fault in a .then handler, are not.
export const requestUnanswered = (error) =>
  Boolean(error?.isAxiosError && !error.response);
